import React from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DiagnosisProps {
  value: string;
  onChange: (value: string) => void;
}

const Diagnosis: React.FC<DiagnosisProps> = ({ value, onChange }) => {
  return (
    <div className="space-y-3">
      <div className="relative">
        <textarea
          id="diagnosis"
          rows={5}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          spellCheck
          lang="en"
          autoCorrect="on"
          placeholder="Enter primary diagnosis, condition details, and clinical observations…"
          className={cn(
            'w-full resize-none rounded-xl border bg-slate-50/50 px-4 py-3 text-sm text-slate-900 transition-all',
            'placeholder:text-slate-400 focus:border-blue-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500/20',
            !value ? 'border-amber-200/80' : 'border-slate-200'
          )}
        />
        {!value && (
          <div
            className="pointer-events-none absolute right-3 top-3 flex items-center gap-1 rounded-md bg-amber-50 px-2 py-1 text-xs text-amber-700"
            title="Required before saving"
          >
            <AlertCircle className="h-3.5 w-3.5" />
            Required
          </div>
        )}
      </div>
      {value && (
        <div className="flex items-center gap-2 rounded-lg border border-emerald-100 bg-emerald-50/80 px-3 py-2 text-sm text-emerald-800">
          <CheckCircle2 className="h-4 w-4 shrink-0" />
          <span>Diagnosis captured — you can add prescription and save when ready.</span>
        </div>
      )}
      <p className="text-xs text-slate-500">
        Spell-check is on — misspelled words are underlined; right-click for suggestions (browser dependent).
      </p>
    </div>
  );
};

export default Diagnosis;
